// noinspection JSAnnotator

import Vue                  from "vue";
import Vuex                 from "vuex";
import Cookies              from "js-cookie";
import vacanciesStoreModule from "./modules/vacancyStore";
import {objectToFormData}   from "./utils/objectToFormData.js";


Vue.use(Vuex);

let cartItemsData=[];
if( window.localStorage && localStorage.getItem("cartItemsData") )
    {
        const data = localStorage.getItem("cartItemsData");
        if (data) {
            cartItemsData = JSON.parse(data)
        } else {
            cartItemsData = []
        }

    }

function showError(response) {
    window.showHeaderMessage(response.message || 'Произошла ошибка', 'error');
}

const reviewLimitMessage = 'Вы уже оценили товар! Благодарим за ваше мнение';


export default new Vuex.Store({
    modules:{
        vacancies:vacanciesStoreModule
    },
    state     : {
        geodata                      : Cookies.getJSON("geodata") || {},
        mainShop                     : Cookies.getJSON("mainShop") || {},
        isViewportDisabled           : !!Cookies.get("DISABLE_META_VIEWPORT"),
        shopAlcoholTime              : {},
        selectedShops                : Cookies.getJSON("selectedShops") || [],
        favoriteProducts             : Cookies.getJSON(BX.message("COOKIE_PREFIX") + "_" + "favorite_products") || [],
        favoriteShops                : Cookies.getJSON("favoriteShops") || [],
        ageConfirmed                 : Cookies.get("ageApproved") ? true : false,
        shareCartUrl                 : "",
        isCityConfirmed              : !!Cookies.get("isCityConfirmed") || false,
        userCityId                   : Cookies.get("userCityId") || null,
        userCity                     : "",
        userHeaderName               : "",
        userDevice                   : Cookies.get("userDevice") || "",
        catalogUploadTimestamp       : null,
        productDetailReviewsCnt      : null,
        cartTotal                    : 0,
        userId                       : 0,
        lastPhoneConfirmTimestamp    : Cookies.get("lastPhoneConfirmTimestamp"),
        regionsData                  : localStorage && localStorage.regionsData ? JSON.parse(localStorage.getItem("regionsData")) : {},
        shopsData                    : localStorage && localStorage.shopsData ? JSON.parse(localStorage.getItem("shopsData")) : {},
        cartItems                    : [],
        productsInCart               : [],
        productDetailTabs            : [],
        productsData                 : [],
        confirmedPhones              : [],
        isPhoneConfirmed             : false,
        catalogFilterExpandedOptions : Cookies.getJSON("catalogFilterExpandedOptions") || [],
        productShopsData             : {},
        mapData                      : {},
        cartData                     : {},
        isOrdersDisabled             : false,
        shopsInSelectedCity          : [],
        vacanciesType                : "",

        promo                        : {
            dateTo           : "",
            discountPageCode : ""
        },
        cartHasUnavailableProducts   : false,
        cartItemsData                : cartItemsData,
        corpOrder                    : "", //замена
        corpOrderInn                 : null,
        // YANDEX CAPTCHA
        yandexSiteKey: '',
        yandexCaptchaCallback: undefined,
        // REVIEWS
        reviewProductId: '',
        reviewPreselectedScore: 0,

    },
    mutations : {
        setReviewProductId( state, value ) {
            state.reviewProductId = value;
        },
        setReviewPreselectedScore( state, value ) {
            state.reviewPreselectedScore = value;
        },
        setYandexSiteKey( state, value ) {
          state.yandexSiteKey = value;
        },
        setYandexCaptchaCallback( state, callback ) {
            state.yandexCaptchaCallback = callback;
        },
        setCorpOrder( state, orderData )
            { //замена
                state.corpOrder=orderData;
            },
        setCartHasUnavailableProducts( state, isHas )
            {
                state.cartHasUnavailableProducts= !!isHas;
            },
        setShopsInSelectedCity( state )
            {
                if( !state.shopsData || !state.shopsData.length )
                    {
                        return;
                    }
                state.shopsInSelectedCity=_.filter(state.shopsData, shop => shop.cityId == state.userCityId);
            },
        setOrdersDisabled( state, isDisabled )
            {
                state.isOrdersDisabled= !!isDisabled;
            },
        setCartData( state, cartData )
            {
                state.cartData=cartData;
            },
        setCartItemsData( state, cartItemsData )
            {
                state.cartItemsData=cartItemsData || [];
                if( window.localStorage )
                    {
                        localStorage.setItem("cartItemsData", JSON.stringify(cartItemsData));
                    }
            },
        setPromoDateTo( state, date )
            {
                state.promo.dateTo=date;
            },
        setPromoDiscountPageCode( state, code )
            {
                state.promo.discountPageCode=code;
            },
        setConfirmedPhones( state, phones )
            {
                state.confirmedPhones=phones;
            },
        setLastPhoneConfirmTimestamp( state, timestamp )
            {
                state.lastPhoneConfirmTimestamp=timestamp;
                Cookies.set("lastPhoneConfirmTimestamp", timestamp);
            },
        setProductsData( state, productsData )
            {
                let resProducts = Object.values(productsData).map(item => ({
                    product_id: item.product_id,
                    xml_id: item.xml_id,
                }));

                let fd = new FormData;
                fd.append('products', JSON.stringify(resProducts));

                fetch(`/api/products/get-data/`, {
                  method: 'POST',
                  body: fd
                })
                  .then(response => response.json())
                  .then(data => {

                      productsData = productsData.map(product =>
                      {
                          const productData=data[ product.product_id ];

                          return {
                              ...product,
                              ...( productData || {} ),
                          };
                      });
                      state.productsData=productsData;
                  })
                  .catch(e => console.log(e));

                state.productsData=productsData;
            },
        setViewportDisabled( state, isDisabled )
            {
                state.isViewportDisabled= !!isDisabled;
                Cookies.set("DISABLE_META_VIEWPORT", state.isViewportDisabled ? 1 : 0, {expires : 30});
            },
        setUserDevice( state, device )
            {
                state.userDevice=device;
                Cookies.set("userDevice", device, {expires : 30});
            },
        setUserId( state, userId )
            {
                state.userId=userId;
            },
        setUserHeaderName( state, userHeaderName )
            {
                state.userHeaderName = userHeaderName;
            },
        toggleCatalogFilterExpandedOptions( state, optionId )
            {
                optionId = +optionId;
                let index = state.catalogFilterExpandedOptions.indexOf(optionId);
                if( ~index )
                    {
                        state.catalogFilterExpandedOptions.splice(index, 1);
                        state.catalogFilterExpandedOptions.splice(index, 1);
                    }
                else
                    {
                        state.catalogFilterExpandedOptions.push(optionId);
                    }
                Cookies.set("catalogFilterExpandedOptions", state.catalogFilterExpandedOptions, {expires : 30});
            },
        setProductShopsData( state, productShopsData ) {
            state.productShopsData=productShopsData;},
        setCartItems( state, cartItems )
            {
                state.cartItems=cartItems;
            },
        setAgeConfirmed( state, confirmed )
            {
                let ageConfirmed  =!!confirmed;
                state.ageConfirmed=ageConfirmed;
                if( ageConfirmed )
                    {
                        Cookies.set("ageApproved", true, {expires : 30});
                    }
                else
                    {
                        Cookies.remove("ageApproved");
                    }
            },
        setCartTotal( state, total )
            {
               state.cartTotal=total;
            },
        deleteMainShop( state )
            {
                state.mainShop={};
                Cookies.set("mainShop", {}, {expires : 30});
                location.reload();
            },
        setShopAlcoholTime( state, shopAlcoholTime )
            {
                state.shopAlcoholTime=shopAlcoholTime;
            },
        setMainShop( state, mainShop )
            {
                let curMainShopId=state.mainShop.id;
                if( _.isObject(mainShop) )
                    {
                        Cookies.set("mainShop", {
                            id        : mainShop.id,
                            shopNum   : mainShop.shopNum || mainShop.num,
                            address   : mainShop.address,
                            cityId    : mainShop.cityId,
                            noAlcohol : mainShop.noAlcohol
                        }, {expires : 30});
                        state.mainShop   =mainShop;
                        let selectedShops=vxCommonStore.state.selectedShops;
                        if (typeof mainShop.id !== 'undefined') selectedShops.push(mainShop.id);
                        vxCommonStore.commit("setSelectedShops", selectedShops);
                        if( mainShop.cityId )
                            {
                                //vxCommonStore.commit('setUserCityId', mainShop.cityId); //при смене города очищаем выбранный магазин
                            }
                    }
                else
                    {
                        state.mainShop={};
                    }
                if( curMainShopId != state.mainShop.id )
                    {
                        location.reload();
                    }
            },
        setUserCityId( state, cityId )
            {
                let curCityId   =state.userCityId;
                state.userCityId=cityId ? +cityId : null;
                Cookies.set("userCityId", state.userCityId, {expires : 30});
                if( !_.isEmpty(state.regionsData) )
                    {
                        vxCommonStore.commit("setUserCity", _.find(state.regionsData.cities, ( city ) =>
                        {
                            return city.id == state.userCityId;
                        }).name);
                    }
                if( curCityId && curCityId != state.userCityId )
                    {
                        vxCommonStore.commit("deleteMainShop"); //при смене города очищаем выбранный магазин
                    }
            },
        setCityConfirmed( state, confirmed )
            {
                state.isCityConfirmed= !!confirmed;
                Cookies.set("isCityConfirmed", state.isCityConfirmed, {expires : 30});
            },
        setUserCity( state, city )
            {
                state.userCity=city;
            },
        setProductsInCart( state, productIds )
            {
                state.productsInCart=_.map(productIds, id => +id);
            },
        setGeoData( state, geoData )
            {
                state.geoData=geoData;
            },
        setMapData( state, mapData )
            {
                state.mapData=mapData;
            },
        setProductDetailTabs( state, productDetailTabs )
            {
                state.productDetailTabs=productDetailTabs;
            },
        setFavoriteShops( state, shopIds )
            {
                shopIds=_.map(shopIds, shopId => +shopId);
                Cookies.set("favoriteShops", shopIds, {expires : 30});
                state.favoriteShops=shopIds;
            },
        addFavoriteShop( state, shopId )
            {
                let shopIds=state.favoriteShops;
                shopId     = +shopId;
                if( !~shopIds.indexOf(shopId) )
                    {
                        shopIds.push(shopId);
                        vxCommonStore.commit("setFavoriteShops", shopIds);
                        showHeaderMessage("Добавлен любимый магазин");
                    }
            },
        deleteFavoriteShop( state, shopId )
            {
                let shopIds=vxCommonStore.state.favoriteShops;
                shopId     = +shopId;
                if( ~shopIds.indexOf(shopId) )
                    {
                        shopIds.splice(shopIds.indexOf(shopId), 1);
                        vxCommonStore.commit("setFavoriteShops", shopIds);
                        showHeaderMessage("Магазин удалён из списка любимых");
                    }
            },
        setFavoriteProducts( state, productIds )
            {
                productIds=_.map(productIds, productId => +productId);
                Cookies.set(BX.message("COOKIE_PREFIX") + "_" + "favorite_products", productIds, {expires : 30});
                state.favoriteProducts=productIds;
            },
        addFavoriteProduct( state, productId )
            {
                let productIds=state.favoriteProducts;
                productId     = +productId;
                if( !~productIds.indexOf(productId) )
                    {
                        productIds.push(productId);
                        vxCommonStore.commit("setFavoriteProducts", productIds);
                        showHeaderMessage("Товар добавлен в <a href=\"/personal/favorite-products/\">избранное</a>");
                    }
            },
        deleteFavoriteProduct( state, productId )
            {
                let productIds=vxCommonStore.state.favoriteProducts;
                productId     = +productId;
                if( ~productIds.indexOf(productId) )
                    {
                        productIds.splice(productIds.indexOf(productId), 1);
                        vxCommonStore.commit("setFavoriteProducts", productIds);
                        showHeaderMessage("Товар удалён из <a href=\"/personal/favorite-products/\">избранного</a>");
                    }
            },
        setProductDetailReviewsCnt( state, cnt )
            {
                state.productDetailReviewsCnt=cnt;
            },
        setCatalogUploadTimestamp( state, timestamp )
            {
                state.catalogUploadTimestamp= +timestamp;
                if( localStorage )
                    {
                        if( localStorage.shopsDataTimestamp && localStorage.shopsDataTimestamp < state.catalogUploadTimestamp )
                            {
                                localStorage.removeItem("shopsData");
                                localStorage.removeItem("shopsDataTimestamp");
                            }
                        if( localStorage.regionsData && localStorage.regionsDataTimestamp < state.catalogUploadTimestamp )
                            {
                                localStorage.removeItem("regionsData");
                                localStorage.removeItem("regionsDataTimestamp");
                            }
                    }
            },
        setCity( state, city )
            {
                state.geodata.city  =city.NAME;
                state.geodata.cityId=city.ID;
                Cookies.remove("geodata");
                Cookies.set("geodata", state.geodata, {expires : 30});
            },
        setSelectedShops( state, shopIds )
            {
                shopIds            =_.uniq(shopIds);
                shopIds            =_.map(shopIds, id => +id);
                state.selectedShops=shopIds;
                Cookies.set("selectedShops", shopIds, {expires : 30});
            },
        loadRegionsData( state ) {
            const response = fetch(`/api/cities/list/`)
                .then(response => response.json())
                .then(data => {
                    state.regionsData = data;
                    if( localStorage ) {
                        try {
                            localStorage.setItem("regionsData", JSON.stringify(state.regionsData));
                            localStorage.setItem("regionsDataTimestamp", moment().unix());
                        } catch( e )
                        {
                            console.log(e);
                        }
                    }
                })
                .catch(e => console.log(e));
        },
    },
    actions: {
        // YANDEX SMART CAPTCHA
        initYandexCaptcha({state, commit}, captchaKey) {
            if (!window.smartCaptcha) {
                return;
            }
            commit('setYandexSiteKey', captchaKey);
            window.smartCaptcha.render('captcha-container', {
                sitekey: captchaKey,
                invisible: true,
                hideShield: true,
                callback: () => {
                    state.yandexCaptchaCallback();
                }
            });
        },
        executeYandexCaptcha({commit}, fn) {
            const captcha = window.smartCaptcha;
            if (!captcha || typeof captcha.reset !== 'function' || typeof captcha.execute !== 'function') {
                return false;
            }

            try {
                commit('setYandexCaptchaCallback', fn);
                captcha.reset();
                captcha.execute();
                return true;
            } catch (error) {
                return false;
            }
        },
        async requestProductRemains({state, dispatch}, {cityId, productId, yandexCaptchaToken}) {
            const params = new URL(window.location.href).searchParams;
            params.set('yatoken', yandexCaptchaToken);
            
            const response = await fetch(`/api/cities/${cityId}/products/${productId}/remains/?${params}`)
            const result = await response.json();
            if (!result.data) showError(result);
            return result;
        },
        async requestProductRemainsAndPrices({state, dispatch}, {cityId, productId, yandexCaptchaToken}) {
            const params = new URL(window.location.href).searchParams;
            params.set('yatoken', yandexCaptchaToken);
            const response = await fetch(`/api/cities/${cityId}/products/${productId}/remains-prices/?${params}`)
            const result = await response.json();
            if (!result.data) showError(result);
            return result;
        },
        async requestProductsRemains({state, dispatch}, {cityId, yandexCaptchaToken}) {
            const params = new URL(window.location.href).searchParams;
            params.set('yatoken', yandexCaptchaToken);
            state.cartItems.forEach(product => {
               params.set(`products[${product.productXmlId}]`, product.quantity);
            });
            const response = await fetch(`/api/cities/${cityId}/shops/can-buy/?${params}`)
            const result = await response.json();
            if (!result.data) showError(result);
            return result;
        },
        async requestShops({state}, cityId) {
            if (!state.userCityId && !cityId) {
                console.error('Отсуствует userCityId и cityId');
                return
            }
            const response = await fetch(`/api/cities/${cityId || state.userCityId}/shops/`, {method: 'GET'});
            const result = await response.json();
            if (result) {
                state.shopsData = result;
                if( localStorage ) {
                    try {
                        localStorage.setItem("shopsData", JSON.stringify(state.shopsData));
                        localStorage.setItem("shopsDataTimestamp", moment().unix());
                        this.commit("setShopsInSelectedCity");
                    } catch( e )
                    {
                        console.log(e);
                    }
                }
            }
        },
        async requestShopsByRegion({state}, regionId) {
            if (!regionId) return;
            const response = await fetch(`/api/regions/${regionId}/shops/`, {method: 'GET'});
            const result = await response.json();
            if (result) {
                state.shopsData = result;
                if( localStorage ) {
                    try {
                        localStorage.setItem("shopsData", JSON.stringify(state.shopsData));
                        localStorage.setItem("shopsDataTimestamp", moment().unix());
                        this.commit("setShopsInSelectedCity");
                    } catch( e )
                    {
                        console.log(e);
                    }
                }
            }
        },
        // REVIEWS
        async requestReviewPermission(_, productId) {
            try {
                const response = await fetch('/api/reviews/check/', {
                    method: 'POST',
                    body: objectToFormData({productId}),
                });
                const result = await response.json();

                if (!response.ok) {
                    showError(result);
                    return false;
                }

                if (result.success) {
                    window.showHeaderMessage(reviewLimitMessage);
                    return false;
                }

                return true;
            } catch (error) {
                showError({});
                return false;
            }
        },
        async requestAddReview({state, dispatch}, {data, yandexCaptchaToken}) {
            const body = objectToFormData(data);
            const params = new URL(window.location.href).searchParams;
            params.set('yatoken', yandexCaptchaToken);
            const response = await fetch(`/api/reviews/?${params}`, {method: 'POST', body});
            const result = await response.json();
            if (!result.data) showError(result);
            return result;
        },
    },
    getters:{
        getYandexSiteKey(state) {
          return state.yandexSiteKey;
        },
        getFavoritesCount(state,getters)
            {
                return state.favoriteProducts.length;
            },
        getCountCartItems(state,getters)
            {
                if(state.cartItems.length===0)
                    {
                        return 0;
                    }
                if(state.mainShop && state.mainShop.id){
                    let items = state.cartItems.filter(item => item.group==='READY');
                    return items.length;
                }else{
                    return state.cartItems.length;
                }
            },
        getCartSum(state,getters)
            {

                let resAvailableBasket = getters.checkAvailableShowPriceBasket;
                if(!resAvailableBasket){
                    return "Список";
                }

                if(parseFloat(state.cartTotal)>0)
                    {
                        return state.cartTotal + " ₽";
                    }else{
                        return "Список";
                }
            },
        getUserHeaderName(state, getters){
            return state.userHeaderName;
        },
        checkAvailableShowPriceBasket(state, getters) {
            if(state.cartItems.length===0) return false
            return state.cartItems.every(item => item.availablePrice)
        },
        //Только в этом массиве есть полная инфа о товарах, а именно availablePrice
        getCartDataItems: (state) => state.cartItemsData[0].items || [],
        //Все ли товары имеют цену
        allCartItemsHasPrice(state, getters) {
            return getters.getCartDataItems.every(item => item.availablePrice)
        },
        // REVIEWS
        getReviewProductId(state) {
            return state.reviewProductId
        },
        getReviewPreselectedScore(state) {
            return state.reviewPreselectedScore
        }
    },
});
